var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5276 13.6297L16.5259 19.8069C17.0025 20.2977 17.7358 20.2588 18.0975 19.6739C19.2114 17.8661 19.8019 15.7703 19.8 13.6309C19.802 11.0624 18.952 8.56986 17.3899 6.56384L10.5276 13.6297ZM7.33288 14.1518V4.921C5.29539 5.22511 3.43277 6.27276 2.0861 7.87208C0.739437 9.47141 -0.00113622 11.5154 1.30849e-06 13.6297C1.30849e-06 18.4942 3.83021 22.44 8.55503 22.44C10.4014 22.44 12.1975 21.8218 13.6709 20.6792L7.33288 14.1518ZM16.2924 3.88183C16.7691 3.39111 16.7385 2.62806 16.1837 2.23398C14.6247 1.1251 12.8536 0.369963 10.9883 0.0188427C10.3235 -0.106661 9.77717 0.410413 9.77717 1.10445V10.5925L16.2924 3.88183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieButton);
export default __webpack_public_path__ + "static/media/pieButton.f91e213047cb9ff243525d5b1d90ad06.svg";
export { ForwardRef as ReactComponent };